import styles from "./SDKInfo.module.scss";
import sdkData from "./SDKData";
import wrapperHOC from "@Utils/wrapperHOC";

const SDKInfo = () => (
  <div className={styles.sdkSection}>
    <h1 className={styles.sectionTitle}>第三方 SDK 使用清单</h1>

    {sdkData.map((sdk, index) => (
      <div key={index} className={styles.sdkItem}>
        <h2 className={styles.sdkName}>
          <strong>{sdk.name}</strong> {sdk?.package ? <code>({sdk.package})</code> : null}
        </h2>
        <ul className={styles.sdkList}>
          <li>
            <strong>用途：</strong> {sdk.purpose}
          </li>
          <li>
            <strong>个人信息字段：</strong> {sdk.fields}
          </li>
          <li>
            <strong>第三方名称：</strong> {sdk.company}
          </li>
          <li>
            <strong>隐私政策详情：</strong>{" "}
            <a
              href={sdk.privacyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.sdkPrivacyUrl}
            >
              点击查看详情
            </a>
          </li>
        </ul>
      </div>
    ))}
  </div>
);

export default wrapperHOC(SDKInfo, {
  componentName: "SDKInfo",
  showForChina: true,
});
